var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgMenuCircleFilled = function SvgMenuCircleFilled(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#111827",
    fillRule: "evenodd",
    d: "M5.103 5.103a9.753 9.753 0 0 1 13.794 0 9.753 9.753 0 0 1 0 13.794 9.753 9.753 0 0 1-13.794 0 9.753 9.753 0 0 1 0-13.794Zm2.395 3.146a.75.75 0 0 0 0 1.5h9.004a.75.75 0 0 0 0-1.5H7.498Zm1.126 3.501a.75.75 0 0 0 0 1.5h6.752a.75.75 0 0 0 0-1.5H8.624Zm1.125 3.502a.75.75 0 0 0 0 1.5h4.502a.75.75 0 0 0 0-1.5H9.749Z",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMenuCircleFilled);
export default ForwardRef;